// @ts-nocheck
import React, { FC } from 'react';
import { Props } from '@lib/constants';
import { AppTemplate } from '@components/4-templates';
import { Spacer, } from '@components/1-atoms';
import { AccountType, BalanceSheetHeader } from '@components/3-organisms';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
import { useStatementBalanceSheet } from '@lib/hooks/useStatement';

import {
  Header,
  IconButton
} from '@components/2-molecules';

import Sandwich from '@assets/icons/sandwich';

const StatementBalanceSheet: FC<Props> = ({ navigation, ...props }) => {

    const date = new Date();
    const [balanceSheet,] = useStatementBalanceSheet({ data: { date: date } });

    const AccountTypes = balanceSheet?.data.length && balanceSheet.data.map((accountType) => {
        return (<AccountType data={accountType} />);
    });

    return (
        <AppTemplate hooks={[balanceSheet]}>

            <Header
                title={"BALANCE SHEET"}
                left={<IconButton icon={<Sandwich />} onPress={navigation?.toggleDrawer} />}
            />
            <Spacer h={1} />

            <BalanceSheetHeader date={date} />
            <Spacer h={1.5} />

            {AccountTypes || null}

            <Spacer h={2} />
        </AppTemplate>
    );
};


export default withForwardedNavigationParams<Props>()(StatementBalanceSheet);